import { render, staticRenderFns } from "./StarterKit.vue?vue&type=template&id=65f5dd8a&scoped=true&"
import script from "./StarterKit.vue?vue&type=script&lang=js&"
export * from "./StarterKit.vue?vue&type=script&lang=js&"
import style0 from "./StarterKit.vue?vue&type=style&index=0&id=65f5dd8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5dd8a",
  null
  
)

export default component.exports